import React from "react";

export function PaisagemCarioca() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-name="Camada 1"
    viewBox="0 0 60 60"
  >
    <defs>
      <linearGradient
        id="a"
        x1={38.49}
        x2={5.59}
        y1={64.47}
        y2={17.48}
        data-name="Gradiente sem nome 7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="b"
        x1={49.66}
        x2={43.81}
        y1={17.74}
        y2={9.39}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="c"
        x1={47.74}
        x2={45.72}
        y1={7.15}
        y2={4.26}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="d"
        x1={47.74}
        x2={45.72}
        y1={22.86}
        y2={19.98}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="e"
        x1={42.27}
        x2={40.12}
        y1={9.57}
        y2={6.49}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="f"
        x1={53.38}
        x2={51.19}
        y1={20.69}
        y2={17.56}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="g"
        x1={52.93}
        x2={52.93}
        y1={20.78}
        y2={20.78}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="h"
        x1={39.8}
        x2={38.01}
        y1={14.84}
        y2={12.29}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="i"
        x1={55.45}
        x2={53.66}
        y1={14.84}
        y2={12.29}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="j"
        x1={41.85}
        x2={40.5}
        y1={20.08}
        y2={18.15}
        data-name="Gradiente sem nome 7"
      />
      <linearGradient
        xlinkHref="#a"
        id="k"
        x1={52.94}
        x2={51.59}
        y1={8.99}
        y2={7.07}
        data-name="Gradiente sem nome 7"
      />
    </defs>
    <path
      d="M50.02 56.26s.04-.06.05-.1c.01-.03.02-.06.03-.08l.03-.11c0-.03 0-.07.01-.1V55.77c0-.04 0-.07-.01-.11 0-.03 0-.06-.01-.09 0-.02-.01-.04-.02-.06-.01-.04-.02-.09-.04-.13 0-.01-.01-.03-.02-.04-.02-.05-.05-.09-.08-.14-2.57-3.64-6.71-5.92-11.22-6.22V46.9c4.59-.53 8.18-4.56 8.17-9.45v-.02c0-1.24-.38-2.45-1.07-3.48l-7.27-10.99a1.015 1.015 0 0 0-1.7 0L29.6 33.95a6.294 6.294 0 0 0-1.07 3.49v.02c0 4.89 3.58 8.93 8.17 9.45v2.08c-2.98.2-5.82 1.26-8.16 3.05-1.36-1.14-2.9-2.06-4.56-2.7-1.69-.66-3.48-1.05-5.29-1.17v-6.52c2.53-.3 4.86-1.56 6.67-3.65 2.05-2.35 3.17-5.47 3.17-8.79 0-.13-.41-3.11-1.25-4.5L18.41 9.85c-.18-.31-.52-.5-.88-.5s-.69.19-.88.5L7.77 24.71c-.83 1.39-1.25 4.38-1.25 4.51 0 3.31 1.13 6.43 3.17 8.79 1.87 2.15 4.31 3.43 6.94 3.67v6.49c-2.52.13-4.99.78-7.18 1.92-2.38 1.24-4.39 3.02-5.81 5.15a.88.88 0 0 0-.11.24c0 .02-.01.04-.02.06-.02.09-.04.17-.04.27 0 .56.46 1.02 1.02 1.02H30.4c.1.02.21.02.31 0H49.1c.06 0 .12 0 .18-.02.02 0 .04 0 .06-.01.04 0 .08-.02.11-.04.02 0 .04-.02.06-.03.04-.02.07-.04.11-.06.02 0 .03-.02.05-.03.02-.01.03-.03.04-.04.03-.03.07-.06.1-.09.02-.02.04-.04.06-.07.02-.03.05-.06.07-.09.02-.02.03-.05.04-.08Zm-3.09-1.49H31.09c-.33-.46-.69-.89-1.07-1.31 2.21-1.6 4.9-2.47 7.69-2.47 3.51 0 6.83 1.39 9.22 3.78ZM30.56 37.45v-.02c0-.84.26-1.67.74-2.37l6.42-9.71 6.42 9.71c.47.7.73 1.52.74 2.36v.02c0 3.76-2.67 6.87-6.14 7.39v-3.74l3.81-3.81c.38-.4.38-1.03 0-1.42-.39-.4-1.04-.41-1.44-.02l-2.37 2.37v-8.2c0-.56-.46-1.02-1.02-1.02s-1.02.46-1.02 1.02v8.21l-2.38-2.38c-.4-.38-1.03-.38-1.42 0-.4.39-.41 1.04-.02 1.44l3.82 3.82v3.72c-3.46-.52-6.13-3.63-6.13-7.39ZM8.58 29.27c.12-.84.51-2.78.96-3.53l8-13.4 7.99 13.4c.45.75.84 2.69.96 3.53-.03 5.28-3.43 9.64-7.81 10.3v-3.5l3.81-3.81c.38-.4.38-1.03 0-1.42-.39-.4-1.04-.41-1.44-.02l-2.37 2.37v-4.57l3.81-3.81.05-.05c.38-.41.36-1.06-.05-1.44s-1.06-.36-1.44.05l-2.37 2.37v-6.72c0-.56-.46-1.02-1.02-1.02s-1.02.46-1.02 1.02v6.73l-2.38-2.38c-.4-.4-1.04-.4-1.44 0-.4.4-.4 1.04 0 1.44l3.82 3.82v4.57l-2.38-2.38c-.4-.4-1.04-.4-1.44 0-.4.4-.4 1.04 0 1.44l3.82 3.82v3.53c-4.51-.52-8.04-4.96-8.07-10.34Zm8.96 20.89c3.92 0 7.57 1.4 10.27 3.94.23.21.44.44.65.66H6.62c2.67-2.88 6.69-4.61 10.92-4.61Z"
      style={{
        fill: "url(#a)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M46.74 8.47c-2.81 0-5.1 2.28-5.1 5.09s2.28 5.1 5.09 5.1 5.1-2.28 5.1-5.1c0-2.81-2.28-5.09-5.09-5.1Zm0 8.15c-1.69 0-3.06-1.37-3.06-3.05 0-1.69 1.37-3.06 3.05-3.06a3.06 3.06 0 0 1 .01 6.12Z"
      style={{
        fill: "url(#b)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M46.73 7.63c.56 0 1.02-.46 1.02-1.02V4.8c0-.56-.46-1.02-1.02-1.02s-1.02.46-1.02 1.02v1.81c0 .56.46 1.02 1.02 1.02Z"
      style={{
        fill: "url(#c)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M46.73 23.35c.56 0 1.02-.46 1.02-1.02v-1.81c0-.56-.46-1.02-1.02-1.02s-1.02.46-1.02 1.02v1.81c0 .56.46 1.02 1.02 1.02Z"
      style={{
        strokeWidth: 0,
        fill: "url(#d)",
      }}
    />
    <path
      d="M41.09 9.37c.19.19.45.3.72.3.27 0 .53-.11.72-.3.4-.4.4-1.04 0-1.44l-1.28-1.27c-.39-.34-.97-.34-1.36 0-.42.37-.46 1.02-.08 1.44l1.27 1.28Z"
      style={{
        fill: "url(#e)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M52.37 17.76c-.4-.4-1.05-.4-1.44 0s-.4 1.05 0 1.44l1.28 1.27c.19.19.45.3.72.3.27 0 .53-.11.72-.3.4-.4.4-1.04 0-1.44l-1.27-1.28Z"
      style={{
        fill: "url(#f)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M52.93 20.78h-.01.01z"
      style={{
        fill: "url(#g)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M37.97 14.58h1.88c.56 0 1.02-.46 1.02-1.02s-.46-1.02-1.02-1.02h-1.88c-.56 0-1.02.46-1.02 1.02s.46 1.02 1.02 1.02Z"
      style={{
        fill: "url(#h)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M55.49 12.54h-1.88c-.56 0-1.02.46-1.02 1.02s.46 1.02 1.02 1.02h1.88c.56 0 1.02-.46 1.02-1.02s-.46-1.02-1.02-1.02Z"
      style={{
        fill: "url(#i)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M39.52 19.76a1.018 1.018 0 0 0 1.74.72l1.28-1.27c.4-.4.4-1.05 0-1.44-.4-.4-1.05-.4-1.44 0l-1.27 1.28c-.19.19-.3.45-.3.72Z"
      style={{
        fill: "url(#j)",
        strokeWidth: 0,
      }}
    />
    <path
      d="M51.65 9.67c.27 0 .53-.11.72-.3l1.27-1.28c.34-.39.34-.97 0-1.36-.37-.42-1.02-.46-1.44-.08l-1.28 1.27a1.024 1.024 0 0 0 .72 1.75Z"
      style={{
        fill: "url(#k)",
        strokeWidth: 0,
      }}
    />
  </svg>
  );
}
